import React from 'react';
import { DropResult } from 'react-beautiful-dnd';

import {
  CmFormErrorMessage,
  CmLabelAndInput,
  CmLabelAndTextarea,
  CmStack,
} from '@/components/uiParts';
import { brandCategoryForm } from '@/pages/menu-managements/categories/service';
import { CategoryFormError } from '@/pages/menu-managements/categories/validate';
import {
  MenuManagementDragItems,
  MenuManagementSearchAndDragArea,
} from '@/pages/menu-managements/components/SearchAndDrag';
import { MenuManagementCardWrapper } from '@/pages/menu-managements/components/Wrapper';
import { SearchItem } from '@/pages/menu-managements/services/searchItem';

type Props = {
  titleJa: string;
  memo: string;
  handleInputName: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleInputMemo: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  error: CategoryFormError;
  searchItems: SearchItem[];
  selectedItems: SearchItem[];
  handleOnDragEnd: (result: DropResult) => void;
  searchItemName: string;
  handleSearchItemNameInput: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleAddSelectItems: (item: SearchItem) => void;
  brandSelectValue: string;
  isSearching: boolean;
  handleDeleteDragItem: (itemId: string) => void;
  handleClickMultipleItemSelect: () => void;
};

export const MenuManagementCategoriesForm: React.FC<Props> = ({
  titleJa,
  memo,
  handleInputName,
  handleInputMemo,
  error,
  searchItems,
  selectedItems,
  handleOnDragEnd,
  searchItemName,
  handleSearchItemNameInput,
  handleAddSelectItems,
  brandSelectValue,
  isSearching,
  handleDeleteDragItem,
  handleClickMultipleItemSelect,
}): JSX.Element => {
  return (
    <MenuManagementCardWrapper>
      <CmStack spacing="20px">
        <CmLabelAndInput
          isRequired
          id={brandCategoryForm.titleJa.key}
          isInvalid={error.titleJa.isError}
          label={brandCategoryForm.titleJa.label}
          fontWeight="bold"
          value={titleJa}
          onChange={handleInputName}
        >
          <CmFormErrorMessage>{error.titleJa.message}</CmFormErrorMessage>
        </CmLabelAndInput>
        <CmLabelAndTextarea
          id={brandCategoryForm.memo.key}
          isInvalid={error.memo.isError}
          label={brandCategoryForm.memo.label}
          fontWeight="bold"
          error={<CmFormErrorMessage>{error.memo.message}</CmFormErrorMessage>}
          value={memo}
          onChange={handleInputMemo}
        />
        <MenuManagementSearchAndDragArea
          targetName="商品"
          handleClickMultipleSelect={handleClickMultipleItemSelect}
          {...{
            brandSelectValue,
            searchItems,
            isSearching,
            selectedItems,
            searchItemName,
            handleSearchItemNameInput,
            handleAddSelectItems,
          }}
        >
          <MenuManagementDragItems
            targetOption="items"
            {...{ selectedItems, handleOnDragEnd, handleDeleteDragItem }}
          />
        </MenuManagementSearchAndDragArea>
      </CmStack>
    </MenuManagementCardWrapper>
  );
};
